import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import "./dropdown.css";
import Loader from "../containers/loader";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import React from "react";
import { Tooltip } from "@mui/material";
import Notification from "../atom/Notification";
import { getUuid } from "../services/api.service";
import { putAudioLibrary, uploadfile } from "../services/api";
import { CustomWidthTooltip } from "../containers/ccsmodule/queues/settings/componenets/settingsBlock";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const DropdownWithFile = (props: any) => {
  const { t } = useTranslation();
  const currentAccount: any = window.localStorage.getItem("currentAccount");

  const { node, data, change, index, handleDDChange, getAudio } = props;
  const [uploadLoader, setUploadLoader] = useState<boolean>(false);
  const inputFileRef = React.useRef<any>();

  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
  };
  const setChange = (value: any) => {
    console.log("valuessss", value);
    let updateData = [...data];
    let filter;
    // debugger
    filter = updateData.filter((n) => {
      return n.name === node.name;
    });
    if (filter[0]) {
      console.log("AMAMAMA", filter[0]);
      filter[0].value = value;
      filter[0].error = false;
    }
    console.log("VTAVTA- Index", index);
    if (index >= 0) {
      console.log("VTAVTA- True", index);
      if (node?.additional?.name === true) {
        change([...updateData], index, node.name);
      } else {
        change([...updateData], index);
      }
    } else {
      change([...updateData]);
    }

    if (node?.Callback) {
      console.log("first", node);
      if (node?.callbackIndex) {
        node.Callback(value, index);
      } else {
        node.Callback(value);
      }
    }
    if (handleDDChange) {
      handleDDChange(index, value);
    }
  };

  useEffect(() => {
    if (node.sort === true) {
      Sorting();
    }
  }, []);

  function Sorting() {
    node.childrens.sort((a: any, b: any) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
  }
  const onBtnClick = () => {
    if (inputFileRef.current && !uploadLoader) {
      inputFileRef.current.click();
    }
  };
  const { token } = useSelector((state: RootState) => state?.Auth);

  console.log("uploadLoader", uploadLoader);
  const onFileChangeCapture = async (e: any) => {
    let image_as_files = e.target.files[0];
    let fileExt = image_as_files.name.split(".").pop();
    console.log("fileExt", fileExt);
    if (fileExt === "wav" || fileExt === "WAV") {
      setUploadLoader(true);
      let file = image_as_files.name
        .replace(`.${fileExt}`, "")
        .replace(/\W+/g, "");
      let formData = new FormData();
      const accountData = JSON.parse(currentAccount);
      formData.append("document", image_as_files);
      formData.append(
        "tenant_id",
        token?.tenant_id === "undefined" ? accountData?.uuid : token?.tenant_id!
      );
      uploadfile(formData, { skipHeader: true }).then((result) => {
        if (result) {
          const payload: any = {
            name: file,
            file: result,
          };
          putAudioLibrary(payload).then((res) => {
            getAudio();
            let result = [...data];
            setUploadLoader(false);

            result.forEach((element) => {
              if (element?.name === node?.name) {
                element.value = res?.uuid;
              }
            });
            change(result);
            setUploadLoader(false);
          });
        }
      });
    } else {
      setUploadLoader(false);
      Notification(
        t("Number.Error"),
        t("Control.Ivr.SelectWavFiles"),
        "danger"
      );
    }
  };
  console.log("dataInsideTable", data);

  return (
    <div
      className={`${node?.disabled ? "input relative opacity-0 translate-y-5 duration-200" : "opacity-100 translate-y-0 duration-200 input relative"}`}
    >
      {/* <CustomWidthTooltip arrow title={`${node?.disabled ? node?.tooltip : ""}`}> */}
      <FormControl disabled={node?.disabled} style={{ width: "100%" }}>
        <InputLabel disabled={node?.disabled} id="demo-simple-select-label">
          {t(node.title) + (node.required ? "* " : " ")}
        </InputLabel>
        <Select
          size="medium"
          style={{ width: "100%" }}
          labelId="demo-simple-select-label"
          id={node.name}
          value={node.value === 0 ? 0 : node.value || ""}
          label={t(node.title)}
          onChange={handleChange}
          disabled={node.disabled}
          error={node.error}
        >
          {node?.childrens &&
            node?.childrens.map((n: any, i: number) => {
              return (
                <MenuItem
                  onClick={() => {
                    console.log("displayprops");
                    setChange(
                      n[node.displayProps?.value] === 0
                        ? 0
                        : n[node.displayProps?.value] || n
                    );
                  }}
                  value={
                    n[node.displayProps?.value] === 0
                      ? 0
                      : n[node.displayProps?.value] || n
                  }
                  key={n.uuid}
                  disabled={n.disabled || false}
                >
                  {n[node?.displayProps?.label] || n}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      {/* </CustomWidthTooltip> */}
      <div
        onClick={() => onBtnClick()}
        className={`block ${node?.disabled && "disabled"}  absolute text-primary-alpha-60 hover:text-primary cursor-pointer right-14  top-1/2 -translate-y-1/2`}
      >
        {uploadLoader ? <Loader size={"sm"} /> : <FileUploadIcon />}{" "}
        {!uploadLoader && t("Control.Ivr.Upload")}
      </div>
      <input
        disabled={node?.disabled}
        type="file"
        className="hidden"
        accept="audio/wav"
        ref={inputFileRef}
        onChangeCapture={onFileChangeCapture}
      />
    </div>
  );
};

export default DropdownWithFile;
